import React, { Suspense } from 'react';

import type { ModalProps } from './ModalClient';

export type { ModalAction, ModalProps } from './ModalClient';

const ModalClient = !process.env.SERVER
  ? process.env.NODE_ENV === 'test'
    ? require('./ModalClient').default
    : React.lazy(() => import('./ModalClient'))
  : null;

function Modal(props: ModalProps) {
  if (ModalClient === null || !props.isOpen) return null;

  if (process.env.NODE_ENV === 'test') {
    const TestModalClient = ModalClient as React.ComponentType<ModalProps>;
    return <TestModalClient {...props} />;
  }

  return (
    <Suspense fallback={null}>
      <ModalClient {...props} />
    </Suspense>
  );
}

export default Modal;
